// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"8fedf5e1","242":"d14f83de","289":"a424b5cb","471":"0e736ed5","646":"cdf436a8","767":"75eacff1","993":"c620f334"}[chunkId] + ".chunk.js";
};